module.exports = __webpack_public_path__ + "static/media/Lopacou.a4ede7e9.jpg";